import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { EligibilityInfo } from '../../../../models/api/view/claim/details/eligibility/eligibility-info';

@Component({
  selector: 'app-eligibility',
  imports: [
    PageHeaderComponent,
    CardComponent,
    TableComponent,
    ColumnComponent,
    DetailPanelComponent,
    DetailItemComponent,
    RouterLink,
  ],
  template: `
    <app-page-header label="Eligibility" />
    <div class="tw-flex tw-gap-4 tw-pb-4">
      <div class="tw-basis-1/3">
        <app-card label="Federal Eligibility Requirements">
          <app-detail-panel [dataSource]="federalRequirements" [showEmpty]="true">
            <app-detail-item
              label="Key Employee"
              name="keyEmployee"
              format="b"
              [showEmpty]="true"
            />
            <app-detail-item
              label="Location has minimum number of employees"
              name="hasMinEmployees"
              format="b"
              [showEmpty]="true"
            />
            <app-detail-item
              label="Yearly Hours"
              name="yearlyHours"
              format="n"
              [showEmpty]="true"
            />
          </app-detail-panel>
        </app-card>
      </div>
      <div class="tw-basis-1/3">
        <app-card label="State Eligibility Requirements">
          <app-detail-panel [dataSource]="stateRequirements" [showEmpty]="true">
            <app-detail-item label="State" name="stateCode" [showEmpty]="true" />
            <app-detail-item
              label="Location has minimum number of employees"
              name="hasMinEmployees"
              format="b"
              [showEmpty]="true"
            />
          </app-detail-panel>
        </app-card>
      </div>
    </div>
    <app-card label="Policies">
      <app-table
        [dataSource]="casePolicyDetails"
        recordLabel="Policy"
        recordLabelPlural="Policies"
      >
        <app-column label="Policy Name" name="policyName" width="35%" />
        <app-column label="Case Time Used" name="timeUsed" width="25%">
          <ng-template #cell let-item>
            {{ item.timeUsed }} {{ item.timeUsedUnit }}
          </ng-template>
        </app-column>
        <app-column
          label="Case Time Available"
          name="timeAvailable"
          width="25%"
        >
          <ng-template #cell let-item>
            {{ item.timeAvailable }} {{ item.timeAvailableUnit }}
          </ng-template>
        </app-column>
        <app-column
          label="Exhaustion Date"
          name="exhaustionDate"
          width="15%"
          format="d"
        />
      </app-table>
      <div class="tw-gap-4 tw-pb-2 tw-pt-4">
        *Case Time Used is based in how much time has been used for this case
        only, as of today.
      </div>
      <div class="tw-gap-4 tw-pb-2">
        **Case Time Available is based on your policy entitlement, minus
        accumulated time used for that policy.
      </div>
      <div class="tw-gap-4 tw-pb-2">
        To view summary of policy entitlement, time used, time pending and time
        remaining, please go to the
        <a routerLink="..">Leave balance on the Claim Summary</a>
        page.
      </div>
    </app-card>
  `,
  styles: ``,
})
export class EligibilityComponent extends BaseComponent implements OnInit {
  federalRequirements: Partial<EligibilityInfo> = {};
  stateRequirements: Partial<EligibilityInfo> = {};
  casePolicyDetails: EligibilityInfo[] = [];

  ngOnInit(): void {
    this.view.showLoading();
    this.loadEligibility();
  }

  async loadEligibility() {
    const response = await this.api.eligibility.get({
      recordSource: this.view.currentClaim().recordSource,
      recordId: this.view.currentClaim().recordId,
    });

    this.federalRequirements =
      response.find((x: EligibilityInfo) => x.stateCode === 'FE') ?? {};
    this.stateRequirements =
      response.find((x: EligibilityInfo) => x.stateCode !== 'FE') ?? {};

    this.casePolicyDetails = response.filter(
      (x: EligibilityInfo) => x.policyName,
    );

    this.view.hideLoading();
  }
}
